import { useMutation } from '@tanstack/react-query';

import ProductsService from '@/services/ProductsService';

export function useDownloadCsv() {
  const mutation = useMutation({
    mutationFn: async ({ fileKey }: { fileKey: string }) => {
      const { url } = await ProductsService.getDownloadUrl(fileKey);
      return { url, fileKey };
    },
  });

  return {
    generateDownloadUrl: mutation.mutateAsync,
    isGenerating: mutation.isPending,
  };
}
